import { isMobile, showPanel, hideAllPanels } from '../utils/overlay';

document.addEventListener('DOMContentLoaded', function() {
    const clickableElements = document.querySelectorAll('[data-target^="asset-item-"]');
    const assetItems = document.querySelectorAll('.strategy-portfolios__asset-item');
    const mainText = document.querySelector('.strategy-portfolios__main-text');
    const closeButtons = document.querySelectorAll('.strategy-portfolios__asset-item__close');
    const backdrop = document.querySelector('.strategy-portfolios__backdrop');

    function showMainText() {
        if (mainText) mainText.classList.remove('is-hidden');
    }

    function hideMainText() {
        if (mainText) mainText.classList.add('is-hidden');
    }

    function removeAllActiveClasses() {
        clickableElements.forEach(el => el.classList.remove('is-active'));
    }

    function closeAll() {
        hideAllPanels(assetItems, backdrop);
        removeAllActiveClasses();
        showMainText();
    }

    function handleShow(targetId, clickedElement) {
        hideAllPanels(assetItems, backdrop);
        removeAllActiveClasses();
        clickedElement.classList.add('is-active');
        showPanel(document.getElementById(targetId), backdrop);
        hideMainText();
    }

    let leaveTimeout;

    clickableElements.forEach(element => {
        element.addEventListener('click', function() {
            if (isMobile()) {
                const targetId = this.getAttribute('data-target');
                if (targetId) handleShow(targetId, this);
            }
        });

        element.addEventListener('mouseenter', function() {
            if (!isMobile()) {
                clearTimeout(leaveTimeout);
                const targetId = this.getAttribute('data-target');
                if (targetId) handleShow(targetId, this);
            }
        });

        element.addEventListener('mouseleave', function() {
            if (!isMobile()) {
                leaveTimeout = setTimeout(closeAll, 200);
            }
        });

        element.addEventListener('keydown', function(e) {
            if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                const targetId = this.getAttribute('data-target');
                if (targetId) handleShow(targetId, this);
            }
        });

        element.style.cursor = 'pointer';
    });

    closeButtons.forEach(btn => {
        btn.addEventListener('click', function(e) {
            e.stopPropagation();
            closeAll();
        });
    });

    if (backdrop) {
        backdrop.addEventListener('click', closeAll);
    }

    document.addEventListener('click', function(e) {
        const isClickable = Array.from(clickableElements).some(el => el.contains(e.target));
        const isInsidePanel = Array.from(assetItems).some(item => item.contains(e.target));
        if (!isClickable && !isInsidePanel) closeAll();
    });
});
